import { render, staticRenderFns } from "./GoalList.vue?vue&type=template&id=3fcbbbca&scoped=true&lang=pug&"
import script from "./GoalList.vue?vue&type=script&lang=ts&"
export * from "./GoalList.vue?vue&type=script&lang=ts&"
import style0 from "./GoalList.vue?vue&type=style&index=0&id=3fcbbbca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcbbbca",
  null
  
)

export default component.exports